import React from "react";
import DataTable from "../../Components/Table";
import { useHistory, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { memberActionCreator } from "../../Redux/Members/actionCreator";
import Loader from "../../Components/Loader/Loader";

const MembersTable = (props) => {
  const { 
    data, 
    tableRef, 
    columns, 
    columnsStatus, 
    setId,
    currentPage,
    pageSize,
    totalPages,
    totalItems,
    onPageChange,
    onPageSizeChange,
    isServerSidePagination
  } = props;
  // console.log("in table : ", props);
  const history = useHistory();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const totalPagesRedux = useSelector((state) => state.members.pagination?.totalPages);

  // console.log("In mamber Table : ");

  const options = {
    search: false,
    selection: true,
    // filtering: true,

    headerStyle: {
      backgroundColor: "#E7E7E7",
      color: "#000",
      fontWeight: "bold",
      fontSize: 18,
      fontFamily: "Mulish",
      padding: "8px 5px",
    },
    cellStyle: {
      padding: "10px",
    },
    maxBodyHeight: "60vh",
    pageSize: pageSize,
    pageSizeOptions: [10, 25, 50, 100],
    searchFieldStyle: {
      marginRight: "6vw",
      width: "15vw",
    },
    filterCellStyle: {
      padding: "5px 18px 5px 8px",
    },
  };

  // Handle page change
  const handlePageChange = (page, pageSize) => {
    // console.log("MembersTable page change:", page, pageSize);
    // Validate page bounds
    if (page < 1) page = 1;
    if (totalPagesRedux && page > totalPagesRedux) page = totalPagesRedux;
    
    // Call parent's pagination handler
    if (onPageChange) {
      onPageChange(page, pageSize);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (pageSize) => {
    // console.log("MembersTable page size change:", pageSize);
    // Call parent's pagination handler
    if (onPageSizeChange) {
      onPageSizeChange(pageSize);
    }
  };

  return (
    <>
      {/* {data.length === 0 ? (
        <Loader />
      ) : ( */}
      
      <DataTable
        tableRef={tableRef}
        title=""
        columns={columns.filter((e) => {
          return columnsStatus[e.field];
        })}
        data={data}
        options={options}
        onRowClick={(event, rowData) => {
          // console.log("Row Data", rowData);
          dispatch(memberActionCreator(rowData));
          history.push(`${path}/member-info/${rowData._id}`);
          setId(rowData._id);
        }}
        // Pagination handlers
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        isServerSidePagination={isServerSidePagination}
      />
      {/* )} */}
    </>
  );
};

export default MembersTable;
